import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'components/UI/Link/Link';
import { toAudString } from 'utils/currency';
import { RemoveSeatsPrompt } from 'components/Cart/Prompts/RemoveSeatsPrompt';

export const UpsellEventSummary = (props) => {
  const { performanceTicket, allowRemove, stepName } = props;
  const { TicketedItems, PerformanceDescription } = performanceTicket;
  const [removeEvent, setRemoveEvent] = useState(null);
  const showPrompt = (event) => {
    setRemoveEvent(event);
  };

  return (
    <>
      <RemoveSeatsPrompt
        active={!!removeEvent}
        event={removeEvent}
        stepName={stepName}
        onRequestClose={() => {
          setRemoveEvent(null);
        }}
      />
      <span className="info-label">Add Ons</span>

      <div>
        <p>
          <strong className="show-name">{PerformanceDescription}</strong>
        </p>

        {TicketedItems.map((ticketedItem) => {
          const { SubLineItems } = ticketedItem;

          return SubLineItems.map((upsell, index) => (
            <div key={index}>
              <div className="col-xs-8">{upsell.SeatTypeDescription}</div>
              <div className="col-xs-4 text-right">{toAudString(upsell.AmountDue)}</div>

              {allowRemove && (
                <Link
                  href="#"
                  noUnderline
                  onClick={() => {
                    showPrompt(performanceTicket);
                  }}
                  variant="secondary"
                  extendClass="link-bold link-remove"
                >
                  Remove
                </Link>
              )}
            </div>
          ));
        })}
      </div>
    </>
  );
};

UpsellEventSummary.propTypes = {
  performanceTicket: PropTypes.array,
  allowRemove: PropTypes.bool,
  stepName: PropTypes.string,
};
